import l_icon_1 from "./assets/learning_icon_1.png"
import l_icon_2 from "./assets/learning_icon_2.png"
import l_icon_3 from "./assets/learning_icon_3.png"

export const learnings = [
  {
    icon: l_icon_1,
    title: "HTML5 / CSS3",
    description: "Découvrez le code qui se cache derrière un site web et apprenez à en structurer et décorer un"
  },
  {
    icon: l_icon_2,
    title: "Javascript",
    description: "Ajouter de l’interaction et des animations à vos sites web avec Javascript"
  },
  {
    icon: l_icon_3,
    title: "Python / Flask / SQL",
    description: "Développer la logistique derrière votre site web avec le langage de programmation populaire python et son framework web Flask"
  }
]


import m_img_1 from "./assets/methode_1.jpg"
import m_img_2 from "./assets/methode_2.jpg"
import m_img_3 from "./assets/methode_3.jpg"
export const methods = [
  {
    img: m_img_1,
    title: "Programme ordonné",
    description: "Nous avons mis au point une carte très précise pour que vous puissiez apprendre chaque langage dans un ordre logique et simple.",
    alt: "Plan ordonné",
    pos: "left"
  },
  {
    img: m_img_2,
    title: "Concentration sur les bases",
    description: "Notre programme traite des bases de la programmation web, vous permettant de créer n'importe quel site web, ou bien de décider de vous spécialiser dans une technologie précise.",
    alt: "Discussion entre deux personnes",
    pos: "right"
  },
  {
    img: m_img_3,
    title: "Apprentissage par la pratique",
    description: "Nous sommes convaincu qu'il n'existe pas de manière plus efficace d'apprendre à coder que de pratiquer énormément. C'est pourquoi chaque section du cursus sera composé de mini projets tout au long de la section, ainsi que d'un gros projet à chaque fin de section.",
    alt: "Travail de groupe",
    pos: "left"
  }
]


export const reasons = [
  {
    title: "Compréhension claire et précise du fonctionnement d'un site web",
    description: "Suite à cette formation, vous comprendrez le fonctionnement d'un site web, du server web aux requêtes HTTP et HTTPS."
  },
  {
    title: "Capacité de créer n'importe quel type de site web",
    description: "Vous posséderez tout les outils techniques pour développer vos propres sites web, de l'affichage frontend à la logistique backend. Vous développerez également un sens du design et découvrirez des outils utilisés par les webdesigners modernes."
  },
  {
    title: "Un portfolio personnalisé avec 3 projets à y ajouter",
    description: "Vous aurez appris à déployer gratuitement votre premier site web personnel, en présentant votre activité avec un design unique à votre personnalité."
  }
]